import { InvoicingResponse } from '@/types/service-response'
import { InvoicingTree } from '@/model/planning/InvoicingTree'

export class Invoicing {
  private constructor (
    readonly employeeId: number,
    readonly shortName: string,
    readonly employeeName: string,
    readonly personalNumber: string,
    readonly tree: InvoicingTree[]
  ) {}

  public static createListFromResponse (data: InvoicingResponse[]): Invoicing[] {
    return data.map((item: InvoicingResponse) => {
      return new Invoicing(
        item.MitarbeiterID,
        item.Kurzzeichen,
        item.FullName,
        item.PersonalNummer,
        InvoicingTree.createListFromResponse(item)
      )
    })
  }
}
